/*
 * API
 * needLoading: { Boolean } 是否需要请求加载时的loading组件
 */
import service from '@/utils/request'

const info = params => {
  return service.get('/api/info', { params: params, needLoading: true, disableClose: true })
}

const history = () => {
  return service.get('/api/history', { needLoading: true, opacity: true })
}

const discount = body => {
  return service.post('/api/discount', body, {
    needLoading: true,
    opacity: true
  })
}

const purchase = body => {
  return service.post('/api/purchase', body, {
    needLoading: true,
    opacity: true
  })
}

const policyCheck = body => {
  return service.post('/api/policy_check', body, { needLoading: true, opacity: true })
}
const googlePolicyCheck = body => {
  return service.post('/api/google_analytics_check', body, { needLoading: true, opacity: true })
}

export default {
  info,
  history,
  discount,
  purchase,
  policyCheck,
  googlePolicyCheck
}



// WEBPACK FOOTER //
// ./src/api/index.js